import React from "react";
import MyTeamCard from "./MyTeamCard";
import CreateCard from "./CreateCard";
import Grid from "@mui/material/Grid";
import NoTeams from "./NoTeams";
import SendVerification from "./SendVerification";

/*
  For the dashboard
*/
const MyTeams = ({
  myTeams,
  myTeamCredits,
  userData,
  publicUser,
  publicUserJoin,
  visitor,
  isVerified,
}) => (
  <section className="container--dashboard_section teams_section">
    <div className="container--team_list-one">
      <Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={2}
      >
        {/* Show private user profile */}
        {!publicUser && !publicUserJoin && (
          <>
            {myTeamCredits !== null && (
              <Grid item>
                {isVerified ? (
                  <CreateCard credits={myTeamCredits} />
                ) : (
                  <SendVerification profileInfo={userData} />
                )}
              </Grid>
            )}
            {myTeams &&
              myTeams.map((team, index) => (
                <Grid item key={index}>
                  <MyTeamCard team={team} visitor={visitor} />
                </Grid>
              ))}
            {!myTeams && (
              <Grid item>
                <NoTeams />
              </Grid>
            )}
          </>
        )}
        {/* Show public user profile */}
        {publicUser && (
          <>
            {userData &&
              userData.Teams?.map((team, index) => (
                <Grid item key={index}>
                  <MyTeamCard team={team} publicUser={publicUser} />
                </Grid>
              ))}
          </>
        )}
        {publicUserJoin && (
          <>
            {myTeams &&
              myTeams.map((team, index) => (
                <Grid item key={index}>
                  <MyTeamCard team={team} publicUserJoin={publicUserJoin} />
                </Grid>
              ))}
          </>
        )}
      </Grid>
    </div>
  </section>
);

export default MyTeams;
